import { Appointment, TaskListItem, TimeManagementListItem } from '@myapp/contract'
import { isMidnightScheduledDate } from './dateHelpers'

export type WeekTimelineEntry =
  | { type: 'appointment'; time: number; appointment: Appointment }
  | { type: 'break'; time: number; startTimeIso: string }
  | { type: 'timeManagement'; time: number; entry: TimeManagementListItem }
  | { type: 'task'; time: number; task: TaskListItem }

export function isAllDayTMEntry(entry: TimeManagementListItem): boolean {
  const start = new Date(entry.startTime)
  const end = new Date(entry.endTime)
  return start.getHours() === 0 && start.getMinutes() === 0 && end.getHours() >= 23
}

interface UnifyParams {
  appointments: Appointment[]
  breakStartIso?: string
  timeManagementEntries?: TimeManagementListItem[]
  tasks?: TaskListItem[]
  isWorkingDay: boolean
}

export function unifyWeekEntries({
  appointments,
  breakStartIso,
  timeManagementEntries,
  tasks,
  isWorkingDay,
}: UnifyParams): WeekTimelineEntry[] {
  if (!isWorkingDay) return []

  const hasAllDayTM = (timeManagementEntries ?? []).some(isAllDayTMEntry)
  const list: WeekTimelineEntry[] = appointments.map((appt) => ({
    type: 'appointment',
    time: new Date(appt.actualStart ?? appt.plannedStart).getTime() - (appt.actualTravelDuration ?? appt.plannedTravelDuration) * 60_000,
    appointment: appt,
  }))

  if (breakStartIso && !hasAllDayTM) {
    list.push({ type: 'break', time: new Date(breakStartIso).getTime(), startTimeIso: breakStartIso })
  }

  for (const entry of timeManagementEntries ?? []) {
    list.push({ type: 'timeManagement', time: new Date(entry.startTime).getTime(), entry })
  }

  for (const task of tasks ?? []) {
    if (!task.plannedStart) continue
    const isAllDay = isMidnightScheduledDate(task.plannedStart)
    list.push({
      type: 'task',
      time: isAllDay ? -Infinity : new Date(task.actualStart ?? task.plannedStart).getTime() - (task.actualTravelDuration ?? task.plannedTravelDuration) * 60_000,
      task,
    })
  }

  list.sort((a, b) => a.time - b.time)
  return list
}
